<template>
    <div class="page">
        <div class="page-header">
            <div class="page-header-title">
                <div class="title">Integração com <span class="color-primary">Facebook</span></div>

                <div v-if="layout.showIntegrations" class="subtitle">
                    Existe<template v-if="qtdTotalAccounts> 1">m</template>
                    {{ qtdTotalAccounts }} conta<template v-if="qtdTotalAccounts > 1">s</template>
                    do Facebook conectada<template v-if="qtdTotalAccounts > 1">s</template>.
                </div>

                <div v-else class="subtitle">
                    Faça a integração de formulários do Facebook para distribuição de Leads.
                </div>
            </div>

            <div class="page-header-actions">
                <ui-button v-if="layout.showIntegrate || layout.showIntegrations"
                    design="md line-primary"
                    class="button-gerenciar"
                    @click="showFacebookUserSelectModal">
                    Gerenciar contas do Facebook
                </ui-button>

                <ui-search-box v-if="layout.showIntegrations" event="marketing-integrations-facebook-search" />

                <ui-button v-if="layout.showIntegrations"
                    design="md primary add-integrations"
                    @click="showFacebookCreateIntegrationModal">
                    Adicionar Integração <i v-if="layout.showIntegrations" class="fal fa-plus" />
                </ui-button>

                <ui-menu-card v-if="layout.showIntegrate || layout.showIntegrations" title="Gerenciar Recurso">
                    <ui-switch :id="'switch-marketing-integrations-facebook-integration-status'"
                        :checked="integrationStatus"
                        label="Desativar todas as integrações"
                        name="remember"
                        design="sm"
                        @click="integrationStatusClick" />
                 </ui-menu-card>
            </div>
        </div>

        <div class="page-content">
            <!-- 
                Componente de Conectar com o Facebook
                Conteúdo deve aparecer quando não está conectado a nunhuma conta do Facebook
            -->
            <div v-if="layout.showConnect" class="connect">
                <div v-if="loader.main" class="load-indicator">
                    <ui-load-indicator :h="50" :stroke="8" bgColor="#e7e9f4" color="#69D296" />
                </div>

                <div v-else class="call-to-action">
                    <img :src="fbIntegrationImageComputed" alt="Conectar minha conta do Facebook" />

                    <div class="caption">
                        Conecte o <strong>Facilita</strong> à sua conta do
                        <strong class="color-primary">Facebook</strong>
                        e faça a integração de <br> filas de distribuição de leads ao seus
                        <strong class="color-primary">formulários</strong> de página.
                    </div>

                    <ui-button design="lg primary" @click="addAccount">Conectar minha conta do Facebook</ui-button>
                </div>
            </div>


            <!-- 
                Componente de adicionar Integração
                Conteúdo deve aparecer quando não se tem nenhuma integração
            -->
            <div v-if="layout.showIntegrate" class="integrate">
                <div v-if="loader.main" class="load-indicator">
                    <ui-load-indicator :h="50" :stroke="8" bgColor="#e7e9f4" color="#69D296" />
                </div>

                <div v-else class="call-to-action">
                    <ui-button design="lg primary" @click="showFacebookCreateIntegrationModal">
                        <i class="fal fa-plus" />
                    </ui-button>
                    <div class="caption">
                        Você ainda não fez nenhuma integração com <br>
                        formulários do <strong class="color-primary">Facebook</strong>.
                    </div>
                </div>
            </div>

            <!-- 
                Listagem de Integrações
                Conteúdo deve aparecer quando se tem uma ou mais integrações
            -->
            <div v-if="layout.showIntegrations" class="integrations">
                <div v-if="loader.main" class="load-indicator">
                    <ui-load-indicator :h="50" :stroke="8" bgColor="#e7e9f4" color="#69D296" />
                </div>

                <div v-else class="integrations-table">
                    <div v-if="!totalRecords"
                        class="integrations-table-no-items">
                        <div>Não encontramos nenhuma <strong>integração</strong>.</div>
                    </div>

                    <ui-overlay-load v-else-if="loader.tableChange"/>

                    <ui-data-table :columns="tableColumns"
                        :sort-by="{ value: 'updated_at', dir: 'desc' }"
                        :per-page="20"
                        :control-fixed="true"
                        :borders="true"
                        :msg="`Encontramos ${totalRecords} registro(s)`"
                        name="facebook"                            
                        search-event="facebook-search"
                        size-control= 'sm'
                        service="facebook"
                        tr-component="marketing/table-line"
                        not-found-icon="fal fa-file-contract"
                        not-found-text="Não existe nenhum formulário cadastrado" />
                </div>
            </div>
        </div>

        <div class="page-footer" />
        <ui-alert 
            name="erro-integration-facebook"
            title="Erro!"
            text="Houve algo de errado ao adicionar a integração"
            btn-type="danger"
            btn-text="teste" />

        <ui-modal-message :text="textComputed"
            :caution="cautionComputed" 
            :iconCircle="true"
            service="facebook"
            icon="fal fa-exclamation-triangle" 
            name="marketing-integrations-facebook-deactivation"
            title="Desativar Integração com Facebook"
            btn-type="danger"
            btn-text="Desativar"
            colorCircle='circle-danger' />

        <ui-modal-message :text="removeAlertMsgComputed"
            :iconCircle="true"
            service="facebook"
            colorCircle="circle-danger"
            icon="fal fa-trash-alt"
            name="marketing-integrations-facebook-delete-configuration"
            title="Confirmar Exclusão da Integração"
            btn-type="danger"
            btn-text="Excluir" />

        <ui-facebook-user-select-modal />

        <ui-facbook-modal-transfer />

        <ui-facebook-create-integration-modal @close="loadFacebookConfigs" />
    </div>
</template>

<script>
    import { uiButton } from "@/components/ui/buttons"
    import { uiLoadIndicator, uiOverlayLoad, uiSearchBox, uiMenuCard, uiDataTable } from '@/components/ui'
    import { uiSwitch } from '@/components/ui/form'
    import uiFacbookModalTransfer from '@/components/ui-facilita/marketing/facebook-modal-transfer'
    import { uiModalMessage } from '@/components/ui/modal'
    import uiFacebookUserSelectModal from './components/facebook-user-select-modal'
    import uiFacebookCreateIntegrationModal from './components/facebook-create-integration-modal'
    import { uiAlert } from '@/components/ui'


    import { facebook, facebookAccounts } from '@/services/axios'

    import helpers from '@/mixins/helpers'

    import { mapGetters } from 'vuex'

    export default {
        components: {
            uiButton,
            uiAlert,
            uiLoadIndicator,
            uiOverlayLoad,
            uiMenuCard,
            uiSwitch,
            uiSearchBox,
            uiModalMessage,
            uiFacebookUserSelectModal,
            uiFacebookCreateIntegrationModal,
            uiDataTable,
            uiFacbookModalTransfer
        },

        mixins: [helpers],

        data() {
            return {
                layout: {
                    showConnect: false,
                    showIntegrate: false,
                    showIntegrations: false,
                },
                loader: {
                    main: true,
                    connect: false,
                    integrate: false,
                    integrations: false,
                    tableChange: false,
                },
                tableColumns: [
                    {
                        title: 'Conta Facebook',
                        size: ''
                    },
                    {
                        title: 'Página Facebook',
                        size: ''
                    },
                    {
                        title: 'ID do Fomulário',
                        size: ''
                    },
                    {
                        title: 'Nome do Formulário',
                        size: ''
                    },
                    {
                        title: 'Etapa e Status do Funil',
                        size: ''
                    },
                    {
                        title: 'Fila de Processamento',
                        size: '',
                    },
                    {
                        title: 'Criado Por',
                        size: '',
                    },
                    {
                        title: 'Data de Criação',
                        size: '',
                    },
                    {
                        title: '',
                        size: '40',
                    },
                    
                ],
                integrationStatus: true,
                qtdTotalAccounts: 0,
                qtdTotalForms: 0,
                actualPage: 0,
                instance: null,
                formDelection: null
            }
        },

        created() {
            this.loadScripts()
            this.loadFacebookConfigs()

            this.$root.$on('marketing-integrations-facebook-search', (event) => {
                this.searchIntegrations(event)
            })

            /** Abre o modal de deletar a configuração */
            this.$root.$on('marketing-integrations-facebook-delete', (event) => {
                this.formDelection = event.form_id
                this.$root.$emit('modal-msg-open-marketing-integrations-facebook-delete-configuration', event.configuration)
            })

            this.$root.$on('marketing-integrations-facebook-delete-success', () => {
                this.loadFacebookConfigs()
                this.$root.$emit("datatable-reload-facebook")
            })

            /** Trata o evento de quando as integrações Facebook são desativadas */
            this.$root.$on('marketing-integrations-facebook-deactivation-success', (event) => {
                this.$toastr.s(event.msg)
                this.loadFacebookConfigs()
                this.integrationStatus = false
            })

            /** Trata o evento de quando a desativação das integrações Facebook é cancelada */
            this.$root.$on('marketing-integrations-facebook-deactivation-cancel', () => {
                this.$root.$emit("datatable-reload-facebook")
                this.integrationStatus = true
            })
        },

        beforeDestroy() {
            this.$root.$off('total-data-table')
            this.$root.$off('alert-msg-open-erro-integration-facebook')
            this.$root.$off('marketing-integrations-facebook-search')
            this.$root.$off('marketing-integrations-facebook-delete')
            this.$root.$off('marketing-integrations-facebook-delete-success')
            this.$root.$off('marketing-integrations-facebook-deactivation-success')
            this.$root.$off('marketing-integrations-facebook-deactivation-cancel')
        },

        computed: {
            ...mapGetters('dataTable', {
                totalRecords: 'getTotal'
            }),
            /**
             * Computed property que retorna a imagem padrão para as integrações Facebook
             */
            fbIntegrationImageComputed() {
                return require('@/assets/imgs/marketing-integracao-facebook.png')
            },
            /**
             * Computed property que retorna uma mensagem customizada para a remoção da integração de um
             * formulário
             */
            removeAlertMsgComputed() {
                return `A integração do formulário <b>${this.formDelection}</b>, será removida e deixaremos de receber os leads.`
            },
            cautionComputed() {
                return '<span><b>Cuidado</b>: Essa ação não poderá ser desfeita.</span>'
            },
            textComputed() {
                return 'Ao desativar a integração com Facebook você também <br> excluirá todas as integrações com formularios.'
            },
            actualConfigPageComputed: {
                get() {
                    return this.actualPage
                },
                set(value) {
                    this.actualPage = value
                }
            }
        },

        methods: {
            /**
             * Evento é disparado quando se clica/altera o valor do switch de "Integração Ativada"
             */
            sizeWindow () {
                return window.screen.width > 1200 ? 'md' : 'lx'
            },
            /**
             * Trata o evento do input de pesquisa das integrações
             */
            searchIntegrations(event) {
                this.$root.$emit('facebook-search', event)
            },
            /**
             * Evento é disparado quando se clica no switch de "Integração Ativada"
             */
            integrationStatusClick(event) {
                event.preventDefault()

                this.$root.$emit('modal-msg-open-marketing-integrations-facebook-deactivation', {
                    method: 'deactivateFacebookIntegration',
                    eventClose: 'marketing-integrations-facebook-deactivation-cancel',
                    eventSuccess: 'marketing-integrations-facebook-deactivation-success'
                })
            },
            /**
             * Carrega todas as configurações de contas conectadas e configurações realizadas
             * fbAccounts = contas (Antigo conta)
             * fgConfigs = form (Antigo forms)
             * */
            loadFacebookConfigs: async function () {
                try {
                    this.$set(this.loader, 'main', true)

                    /** Realiza uma requisição no backend para verificar se existem contas conectadas */
                    let response = await facebookAccounts.dataTable({})
                    this.qtdTotalAccounts = response.data.total || response.data.recordsTotal

                    /** Realiza uma requisição no backend para verificar se existem formulários integrados */
                    response = await facebook.dataTable({})
                    this.qtdTotalForms = response.data.total || response.data.recordsTotal

                    this.$set(this.layout, 'showConnect', !this.qtdTotalAccounts)
                    this.$set(this.layout, 'showIntegrate', this.qtdTotalAccounts && !this.qtdTotalForms)
                    this.$set(this.layout, 'showIntegrations', this.qtdTotalForms)

                } catch (error) {
                    console.log(error)

                } finally {
                    this.$set(this.loader, 'main', false)
                }
            },
            /**
             * Inicializa o SDK de integração do Facebook
             */
            initFacebookSDK() {
                window.fbAsyncInit = () => {
                    /** A variável FB não foi declarada por vir do script de SDK do Facebook */
                    // eslint-disable-next-line no-undef
                    FB.init({
                        appId: '230535925032915',
                        xfbml: false,
                        version: 'v17.0'
                    })
                }
            },
            /**
             * Inicializa os scripts de configuração do SDK de integração do Facebook
             */
            loadScripts() {
                /** Não é possível criar elementos script dinâmicos utilizando o $refs */
                let js, fjs = document.getElementsByTagName('script')[0]
                if (document.getElementById('facebook-jssdk')) return

                this.initFacebookSDK()

                js = document.createElement('script')
                js.id = 'facebook-jssdk'
                js.crossorigin = 'anonymous'
                js.defer = true
                js.async = true
                js.src = "https://connect.facebook.net/en_US/sdk.js"
                fjs.parentNode.insertBefore(js, fjs)
            },
            /**
             * Evento é disparado ao clicar no botão "Gerencia contas do Facebook"
             * Mostra o MODAL de gerenciar as contas do Facebook
             */
            showFacebookUserSelectModal() {
                this.$root.$emit('datatable-reload-scroll-facebook')
                this.$root.$emit('modal-open-marketing-integrations-facebook-user-select')
            },
            /**
             * Evento é disparado ao clicar no botão "Gerencia contas do Facebook"
             * Mostra o MODAL de Criar Nova Integração
             */
            showFacebookCreateIntegrationModal() {
                this.$root.$emit('modal-open-marketing-integrations-facebook-create-integration')
            },
            /**
             * Direciona o usuário para a página de autenticação
             */
            addAccount() {
                window.open(`https://www.appfacilita.com/wp-json/api/facebook/login?instance=${this.getInstance()}`)
            },
            onTableTheadScroll() {
                this.$refs.tableTbody.scrollLeft = this.$refs.tableThead.scrollLeft
            },
            onTableTbodyScroll() {
                this.$refs.tableThead.scrollLeft = this.$refs.tableTbody.scrollLeft
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>